export const selectScoringState = (state) => state?.writing?.scoring;
